// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__20VZF","footer":"ModalUpdate_footer__8qRGu"};